import { useMutation, useQueryClient } from "@tanstack/react-query";
import { http } from "../../utils/httpCommon";
import { useApiUrls } from "../useApiUrl";

export const useAutoSequenceRoutes = () => {
  const client = useQueryClient();
  const hookUrls = useApiUrls();
  const { autoSequenceRoutes } = hookUrls;
  return useMutation({
    mutationFn: async (routeIds: number[]) => {
      await http.post(autoSequenceRoutes(routeIds));
      return routeIds;
    },
    onMutate: () => {
      // Cancel any outgoing refetch requests to avoid overwriting optimistic update
      client.cancelQueries({
        queryKey: ["planning", "shipment-details"],
      });
    },
    onError: () => {
      // Only invalidate on error to refresh and show error state
      client.invalidateQueries({
        queryKey: ["planning", "shipment-details"],
      });
      client.invalidateQueries({
        queryKey: ["plannedRoutes"],
      });
    },
    // Don't use onSettled - let the polling hook handle the refresh when backend completes
  });
};
